exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body {\n  font-family: Lato, Roboto, Noto, Helvetica, Tahoma, Arial, \"Microsoft YaHei New\", \"Microsoft Yahei\", \"Noto Sans CJK SC\", \"Noto Sans CJK\", \"\\5FAE\\8F6F\\96C5\\9ED1\", \"\\5B8B\\4F53\", SimSun, STXihei, \"\\534E\\6587\\7EC6\\9ED1\", \"PingFang SC\", sans-serif;\n}\n.serif {\n  font-family: Baskerville, \"Lucida Bright\", \"Times New Roman\", \"Times\";\n}\n.resetButton {\n  border: none;\n  background-color: none;\n}\n#ticketSelection {\n  padding: 2%;\n  box-sizing: border-box;\n  background-color: #F6F6F6;\n}\n#ticketSelection p {\n  height: 30px;\n  width: 280px;\n  color: #2E2E2E;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 30px;\n  margin: 2% 0 2% 0;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/catalogo/reservation/TicketSelection.less
// module id = 1384
// module chunks = 0